import { msg } from '@lit/localize';

const translationMap: Record<string, () => string> = {
    asia365: () => msg('asia365', { id: 'brand.asia365' }),
    dorado: () => msg('dorado', { id: 'brand.dorado' }),
    kuoni: () => msg('kuoni', { id: 'brand.kuoni' }),
    kontiki: () => msg('kontiki', { id: 'brand.kontiki' }),
    manta: () => msg('manta', { id: 'brand.manta' }),
    privatesafaris: () => msg('privatesafaris', { id: 'brand.privatesafaris' }),
};

export function getTranslationBy(brand: string): string {
    return translationMap[brand]?.() ?? brand.charAt(0).toUpperCase() + brand.slice(1);
}
